module.exports = __webpack_public_path__ + "static/media/lato-latin-300-normal.ad7de4e1.woff";